import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil, timer } from 'rxjs';
import { CartFeedbackEvent, CartFeedbackService } from '../../../core/services/cart-feedback.service';

@Component({
  selector: 'app-cart-feedback-toast',
  templateUrl: './cart-feedback-toast.component.html',
  styleUrls: ['./cart-feedback-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartFeedbackToastComponent implements OnInit, OnDestroy {
  event: CartFeedbackEvent | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(private feedback: CartFeedbackService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.feedback.event$
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this.event = event;
        this.cdr.markForCheck();
        if (event) {
          timer(2200).pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.feedback.clear();
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

